import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Discussion, DiscussionListConfig } from "../../../../../models";

@Component({
  selector: "discussion-preview",
  templateUrl: "./discussion-preview.component.html",
  styleUrls: [
    "./discussion-preview.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DiscussionPreviewComponent {
  private defaultUserImg: string =
    "../../../../../../../assets/images/uMuzi/african-mask.png";
  @Input() query: DiscussionListConfig;
  @Input() discussion: Discussion;
  @Output() setTagTo = new EventEmitter<any>();

  public setTagFeed(tag: string) {
    this.setTagTo.emit(tag);
  }

  public onToggleUpvote(upvoted: boolean) {
    this.discussion.voted.upVote = upvoted;

    if (this.discussion.voted.downVote && this.discussion.voted.upVote) {
      this.onToggleDownvote(false);
    }

    if (upvoted) {
      this.discussion.upVoteCount++;
    } else {
      this.discussion.upVoteCount--;
    }
  }

  public onToggleDownvote(downvoted: boolean) {
    this.discussion.voted.downVote = downvoted;

    if (this.discussion.voted.downVote && this.discussion.voted.upVote) {
      this.onToggleUpvote(false);
    }

    if (downvoted) {
      this.discussion.downVoteCount++;
    } else {
      this.discussion.downVoteCount--;
    }
  }

  public onToggleBookmark(bookmarked: boolean) {
    this.discussion.bookmarked = bookmarked;

    if (bookmarked === true) {
      this.discussion.bookmarkCount++;
    } else if (bookmarked === false) {
      this.discussion.bookmarkCount--;
    }
  }
}
